// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ILetterCommunicationView
 */
export interface ILetterCommunicationView {
    /**
     * 
     * @type {string}
     * @memberof ILetterCommunicationView
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof ILetterCommunicationView
     */
    url?: string;
}

/**
 * Check if a given object implements the ILetterCommunicationView interface.
 */
export function instanceOfILetterCommunicationView(value: object): value is ILetterCommunicationView {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ILetterCommunicationViewFromJSON(json: any): ILetterCommunicationView {
    return ILetterCommunicationViewFromJSONTyped(json, false);
}

export function ILetterCommunicationViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): ILetterCommunicationView {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function ILetterCommunicationViewToJSON(json: any): ILetterCommunicationView {
    return ILetterCommunicationViewToJSONTyped(json, false);
}

export function ILetterCommunicationViewToJSONTyped(value?: ILetterCommunicationView | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'url': value['url'],
    };
}

